module.exports = __webpack_public_path__ + "img/03.70c2f584.png";